import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth as useClerkAuth } from '@clerk/clerk-react';
import { useAuth } from '../../context/AuthContext';
import { Loader2 } from 'lucide-react';
import { loginFor } from '../../utils/safeRedirect';
import AccountPending from './AccountPending';
import { NotAvailableHere } from './RegionGate';
import { useRegion } from '../../utils/blockedRegion';

const ProtectedRoute = ({ children }) => {
  // We're using both auth contexts during the transition
  const { isAuthenticated: isAppAuthenticated, loading: appLoading, clerkSignedIn } = useAuth();
  const { isLoaded: isClerkLoaded } = useClerkAuth();
  // Held steady by AuthContext: Clerk can report a signed-in person as signed
  // out for a moment, and acting on that sent them to /login and straight back
  const isSignedIn = clerkSignedIn;
  const location = useLocation();
  // A device in a country the Cloudflare rule blocks, through a VPN (utils/blockedRegion.js): the API refuses it too
  const region = useRegion();

  if (region === 'blocked') {
    return (
      <div className="flex min-h-screen items-center justify-center px-4">
        <NotAvailableHere />
      </div>
    );
  }

  if (!isClerkLoaded) {
    return (
      <div className="flex justify-center items-center min-h-screen"
      >
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!isSignedIn) {
    // Back here after signing in: an email's link to a setting or a user
    return <Navigate to={loginFor(location)} replace />;
  }

  // Signed in to Clerk: only the app user is missing (still loading, or the API
  // failed). /login would pass the session straight on and bounce them.
  if (appLoading || !isAppAuthenticated) {
    return <AccountPending />;
  }

  return children;
};

export default ProtectedRoute;
